import React, { useContext } from "react"
import BlogListTemplate from "../modules/blog/blogList/BlogList.template"
import SEO from "../common/seo/seo"
import Layout from "../common/layout/layout"
import BlogPagination from "../modules/blog/blogList/components/BlogListPagination"
import { graphql } from "gatsby"
import LocaleContext, { LocaleProvider } from "../context/LocaleContext"
import translate, { keys } from "../translation/translator"

const Blog = ({ data }) => {
  const postsPerPage = 10
  const totalCountPosts = data.blogs.totalCount
  const locale = useContext(LocaleContext)
  return (
    <Layout>
      <SEO
        title={translate(keys.BLOG_META_TITLE, locale)}
        description={translate(keys.BLOG_META_DESCRIPTION, locale)}
      />
      <LocaleProvider>
        <BlogListTemplate
          mostReadBlogs={data.mostReadBlogs.edges}
          blogs={data.blogs.edges}
          categories={data.categories.edges}
        />
      </LocaleProvider>
      <BlogPagination
        currentPage={1}
        numberOfPages={Math.ceil(totalCountPosts / postsPerPage)}
      />
    </Layout>
  )
}

export default Blog

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }

    blogs: allContentfulPosts(
      limit: 6
      filter: { node_locale: { eq: "en-US" } }
    ) {
      totalCount
      edges {
        node {
          id
          slug
          title
          timeToRead
          intro {
            content {
              nodeType
              content {
                value
              }
            }
          }
          categories {
            slug
            name
          }
          mainImage {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          date(formatString: "DD MMMM ")
          author {
            id
            name
            slug
            email
            avatar {
              fluid(maxWidth: 200) {
                ...GatsbyContentfulFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }
    mostReadBlogs: allContentfulPosts(
      filter: { node_locale: { eq: "en-US" } }
    ) {
      totalCount
      edges {
        node {
          id
          slug
          title
          timeToRead
          intro {
            content {
              nodeType
              content {
                value
              }
            }
          }
          categories {
            slug
            name
          }
          mainImage {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          date(formatString: "DD MMMM ")
          author {
            id
            name
            slug
            email
            avatar {
              fluid(maxWidth: 200) {
                ...GatsbyContentfulFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }
    categories: allContentfulCategories(
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          slug
          name
          order
          contentfulparent {
            name
          }
          categories {
            name
            slug
          }
        }
      }
    }
  }
`
